const sections = [
  {
    title: 'Money rules',
    items: [
      'Each member’s total payout for a cycle is capped at what they contribute (or have actually paid in the ledger) multiplied by the cycle length.',
      'Payout per slot = member total for the cycle ÷ their desired payouts per cycle.',
      "Monthly guardrail: stacked payouts in a month cannot exceed the box's monthly contributions (sum of each member's contribution amount). Saving a schedule fails if this is exceeded.",
    ],
  },
  {
    title: 'Schedule builder rules',
    items: [
      'Cycle months ≥ 1 and payouts per month ≥ 1.',
      'Every slot must have at least one member; members can share a slot.',
      'Every member must appear at least once across the cycle.',
      'Desired payouts per member determine how many times they appear; auto-distribute spreads them across slots.',
      'If a month’s combined payouts exceed the monthly contribution sum, the save is blocked with an error.',
    ],
  },
  {
    title: 'Box cloning',
    items: [
      'Only organizers can clone a box.',
      'Cloning copies members (active), schedule assignments, custom order, desired payout counts, and custom payout dates with a new start date.',
      'Member IDs are remapped; ledger and audit history are not copied.',
    ],
  },
  {
    title: 'Member payout preferences',
    items: [
      'desired_payouts_per_cycle must be a positive integer and cannot exceed cycle_months × payouts_per_month.',
      'Leave the field blank to use the schedule’s assigned slot count as the default.',
      'More desired payouts means smaller per-slot amounts, but the same total over the cycle.',
    ],
  },
  {
    title: 'Dates and ordering',
    items: [
      'Organizer can edit payout dates; multiple members can share a date/slot.',
      'When no custom dates exist, payout dates are derived from the box start date (30-day month cadence).',
      'Custom dates persist even if assignments are reloaded.',
    ],
  },
  {
    title: 'Ledger tie-in',
    items: [
      'If a member has ledger contributions recorded, payouts use that paid-in total; otherwise, they use the planned contribution amount.',
      'Use ledger entries for contributions and payouts to keep totals accurate.',
    ],
  },
]

export default function Rules() {
  return (
    <div className="px-4 sm:px-6 lg:px-8">
      <div className="max-w-5xl mx-auto py-8 space-y-10">
        <div className="text-center">
          <p className="text-sm uppercase tracking-wide text-primary-600 font-semibold">Box rules</p>
          <h1 className="text-3xl sm:text-4xl font-bold text-gray-900 mt-2">How BoxHand keeps payouts fair</h1>
          <p className="mt-4 text-base text-gray-600 max-w-3xl mx-auto">
            These rules are applied automatically when you build or edit a schedule so a box never pays out more than it
            brings in and every member is treated consistently.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {sections.map((section) => (
            <div key={section.title} className="rounded-3xl border border-gray-100 bg-white p-6 shadow-sm">
              <h2 className="text-lg font-semibold text-gray-900">{section.title}</h2>
              <ul className="mt-3 space-y-3 text-sm text-gray-700">
                {section.items.map((item) => (
                  <li key={item} className="flex items-start gap-3">
                    <span className="mt-1 h-2 w-2 rounded-full bg-primary-500 flex-shrink-0" />
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="rounded-3xl border border-primary-100 bg-primary-50 p-6 shadow-sm">
          <h3 className="text-lg font-semibold text-primary-900">Quick organizer checklist</h3>
          <ul className="mt-3 space-y-2 text-sm text-primary-900">
            <li>Set cycle months and payouts per month so every member can appear at least once.</li>
            <li>Use auto-distribute, then adjust slots for members with higher desired payouts.</li>
            <li>Make sure monthly totals stay within the monthly contribution sum; the builder will block invalid saves.</li>
            <li>Record contributions in the ledger so payout amounts stay in sync with what was actually paid in.</li>
          </ul>
        </div>
      </div>
    </div>
  )
}
